import { Typography } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import CustomLink from 'src/components/CustomLink';

import { useStyles } from './useStyles';

export const UnauthenticatedPageFooterTextLink = ({ className, text, link, from }) => {
  const styles = useStyles();

  return (
    <Typography
      className={cx(styles.root, className)}
      variant="body2"
    >
      {text && <span className={styles.text}>{text}</span>}
      {link && (
        <CustomLink
          to={link.to}
          className={styles.link}
          data-testid={link.testId}
          state={{ from }}
        >
          {link.text}
        </CustomLink>
      )}
    </Typography>
  );
};

UnauthenticatedPageFooterTextLink.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  link: PropTypes.shape({
    to: PropTypes.string,
    testId: PropTypes.string,
    text: PropTypes.string,
  }),
  from: PropTypes.string,
};

UnauthenticatedPageFooterTextLink.defaultProps = {
  className: null,
  text: null,
  link: null,
  from: null,
};
